import { api as com, apiFuns } from "sw-hic";
const api = {
  /*********** 就诊号 ***********/
  Reg: apiFuns.genStandard("reg", "/api/op"),
  /*********** 患者 ***********/
  Patient: apiFuns.genStandard("patient", "/api/patient"),
  /*********** 联系人 ***********/
  PatientContact: apiFuns.genStandard("contact", "/api/patient"),
  Diagnosis: apiFuns.genStandard("diagnosis", "/api/patient"),
  /*********** 住院记录 ***********/
  Hospitalization: {
    ...apiFuns.genStandard("hospitalization", "/api/ip", false, true),
    getStayTimes: (patientCode) => apiFuns.get(`/api/ip/hospitalization/times/${patientCode}`),
    cancel: (id) => apiFuns.put(`/api/ip/hospitalization/${id}/cancel`),
    checkIn: (id, para) => apiFuns.put(`/api/ip/hospitalization/${id}/checkin`, para), // 入科
  },
  /*********** 住院通知单 ***********/
  IpNotice: apiFuns.genStandard("ipNotice", "/api/op"),
  /*********** 住院诊断 ***********/
  IpDiagnosis: apiFuns.genStandard("ipDiagnosis", "/api/ip"),
  /*********** 预交金 ***********/
  Deposit: {
    ...apiFuns.genStandard("deposit", "/api/ip"),
    refund: (para) => apiFuns.put(`/api/ip/deposit/${para.id}/refund`, para),
    sum: (para) => apiFuns.get(`/api/ip/deposit/sum`, para),
  },
  /*********** 白条 ***********/
  Ious: apiFuns.genStandard("ious", "/api/ip"),
  /*********** 记账 ***********/
  Billing: {
    ...apiFuns.genStandard("billing", "/api/ip", true),
    sum: (para) => apiFuns.get(`/api/ip/billing/sum`, para),
  },
  /*********** 床位 ***********/
  Bed: {
    ...apiFuns.genStandard("bed", "/api/ip"),
    wrap: (id, hospId) => apiFuns.post(`/api/ip/bed/${id}/wrap/${hospId}`),
    cancel: (id) => apiFuns.del(`/api/ip/bed/${id}/wrap`),
    primary: (id) => apiFuns.put(`/api/ip/bed/${id}/primary`),
    exchange: (id, tgtId) => apiFuns.put(`/api/ip/bed/${id}/exchange/${tgtId}`),
    fee: (id) => apiFuns.get(`/api/ip/bed/${id}/feeStandard`),
  },
  HospitalizationFile: {
    statistic: () => apiFuns.get(`/api/proxy/hospitalizationFile/statistic`),
    exportFile: (para) => apiFuns.download(`/api/proxy/hospitalizationFile/file?startDateSt=${para.startDateSt}&startDateEd=${para.startDateEd}&wardCode=${para.wardCode}&keyword=${para.keyword}`, para, null)
  }
};
export default api;
